<template>
    <rkm-form ref="RkmForm">
        <rkm-row>
            <rkm-col>
                <span><strong>Profissinal:</strong></span>
                <p>{{ data.form.lotacao.profissional.nome }}</p>
            </rkm-col>

            <rkm-col>
                <span><strong>CBO:</strong></span>
                <p>{{ data.form.lotacao.ocupacao.codigo }} - {{ data.form.lotacao.ocupacao.nome }}</p>
            </rkm-col>

            <rkm-col>
                <span><strong>Paciente:</strong></span>
                <p>{{ data.form.paciente.nome }}</p>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <span>
                    <strong>CID10 Principal:</strong>
                    <template v-if="data.model.cid">
                        {{ data.model.cid.codigo }} - {{ data.model.cid.nome }}
                    </template>
                </span>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-area
                    title="Procedimentos médicos"
                    type="section"
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :fields="fields.table"
                                :items="data.form.procedimentos.concat(data.model.procedimentos)"
                                hide-filters
                                hide-pagination
                                tag="div"
                            >

                                <template v-slot:cell(info)="row">
                                    <div v-if="Number.isInteger(row.item.id)">
                                        <rkm-icon
                                            :id="`pronto-atendimento-procedimento-info-modal-${row.item.id}`"
                                            class="mr-2"
                                            icon="info-circle"
                                        />
                                        <rkm-popover
                                            :target="`pronto-atendimento-procedimento-info-modal-${row.item.id}`"
                                            triggers="hover"
                                        >
                                             <div><strong>Data/Hora:</strong> {{ row.item.dataHora }}</div>
                                             <div><strong>Setor:</strong> {{ row.item.centroCusto.setor.nome }}</div>
                                             <div><strong>Profissional:</strong> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                                             <div><strong>Class. risco:</strong> {{ row.item.classificacaoRisco.nome }}</div>
                                        </rkm-popover>
                                    </div>
                                </template>

                                <template v-slot:cell(codigo)="row">
                                    <div v-if="row.item.procedimento.codigo">
                                        {{ row.item.procedimento.codigo | formatProcedimento }}
                                    </div>
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-area
                    title="Procedimentos de enfermagem"
                    type="section"
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :fields="fields.table"
                                :items="data.form.atendimentoTriagem.procedimentos.concat(
                                    data.form.atendimentoEnfermagem.procedimentos,
                                    data.form.pacienteObservacao ? data.form.pacienteObservacao.procedimentos : []
                                )"
                                hide-filters
                                hide-pagination
                                tag="div"
                            >
                                <template v-slot:cell(info)="row">
                                    <div v-if="Number.isInteger(row.item.id)">
                                        <rkm-icon
                                            :id="`pronto-atendimento-procedimento-info-modal-${row.item.id}`"
                                            class="mr-2"
                                            icon="info-circle"
                                        />
                                        <rkm-popover
                                            :target="`pronto-atendimento-procedimento-info-modal-${row.item.id}`"
                                            triggers="hover"
                                        >
                                            <div><strong>Data/Hora:</strong> {{ row.item.dataHora }}</div>
                                            <div><strong>Setor:</strong> {{ row.item.centroCusto.setor.nome }}</div>
                                            <div><strong>Profissional:</strong> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                                            <div><strong>Class. risco:</strong> {{ row.item.classificacaoRisco.nome }}</div>
                                        </rkm-popover>
                                    </div>
                                </template>

                                <template v-slot:cell(codigo)="row">
                                    <div v-if="row.item.procedimento.codigo">
                                        {{ row.item.procedimento.codigo | formatProcedimento }}
                                    </div>
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-area
                    title="Procedimentos de exames de imagem"
                    type="section"
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :fields="fields.table"
                                :items="data.form.atendimentoExameImagem.procedimentos"
                                hide-filters
                                hide-pagination
                                tag="div"
                            >
                                <template v-slot:cell(info)="row">
                                    <div v-if="Number.isInteger(row.item.id)">
                                        <rkm-icon
                                            :id="`pronto-atendimento-procedimento-info-modal-${row.item.id}`"
                                            class="mr-2"
                                            icon="info-circle"
                                        />
                                        <rkm-popover
                                            :target="`pronto-atendimento-procedimento-info-modal-${row.item.id}`"
                                            triggers="hover"
                                        >
                                            <div><strong>Data/Hora:</strong> {{ row.item.dataHora }}</div>
                                            <div><strong>Setor:</strong> {{ row.item.centroCusto.setor.nome }}</div>
                                            <div><strong>Profissional:</strong> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                                        </rkm-popover>
                                    </div>
                                </template>

                                <template v-slot:cell(codigo)="row">
                                    <div v-if="row.item.procedimento.codigo">
                                        {{ row.item.procedimento.codigo | formatProcedimento }}
                                    </div>
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-area
                    title="Desfecho do atendimento"
                    type="section"
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                @change="handleDesfechoChange"
                                v-model="data.model.finalizacao.desfechoId"
                            >
                                <rkm-form-radio :value="enums.desfecho.ALTA_MEDICA">Alta médica</rkm-form-radio>
                                <rkm-form-radio :value="enums.desfecho.EVASAO">Evasão</rkm-form-radio>
                                <rkm-form-radio :value="enums.desfecho.ENCAMINHAMENTO_HOSPITALAR">Transferência / Encaminhamento hospitalar</rkm-form-radio>
                                <rkm-form-radio :value="enums.desfecho.OBITO">Óbito</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="data.model.finalizacao.desfechoId == enums.desfecho.EVASAO">
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.evasao.motivo"
                    label="Motivo da evasão"
                    v-model="data.model.finalizacao.evasao.motivo"
                />
            </rkm-col>
        </rkm-row>

        <template v-if="data.model.finalizacao.desfechoId == enums.desfecho.ENCAMINHAMENTO_HOSPITALAR">
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        v-if="data.model.finalizacao.encaminhamentoHospitalar.unidadeOutra === false"
                        :options="data.form.unidades"
                        :validations="validations.encaminhamentoHospitalar.unidadeId"
                        label="Unidade de encaminhamento"
                        text-field="nomeFantasia"
                        v-model="data.model.finalizacao.encaminhamentoHospitalar.unidadeId"
                        value-field="id"
                    >
                        <rkm-form-select-option
                            :value="null"
                            slot="first"
                        >
                            Selecione
                        </rkm-form-select-option>
                    </rkm-form-select>

                    <rkm-form-input
                        v-else
                        :validations="validations.encaminhamentoHospitalar.unidadeNome"
                        label="Nome"
                        v-model="data.model.finalizacao.encaminhamentoHospitalar.unidadeNome"
                    />
                </rkm-col>

                <rkm-col
                    class="pt-2"
                    cols="2"
                >
                    <div class="d-flex mt-4">
                        <rkm-form-checkbox
                            inline
                            v-model="data.model.finalizacao.encaminhamentoHospitalar.unidadeOutra"
                        >
                            Outra
                        </rkm-form-checkbox>
                    </div>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.tiposTransporte"
                        label="Tipo de transporte"
                        text-field="nome"
                        v-model="data.model.finalizacao.encaminhamentoHospitalar.tipoTransporteId"
                        value-field="id"
                    >
                        <rkm-form-select-option
                            :value="null"
                            slot="first"
                        >
                            Selecione
                        </rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.encaminhamentoHospitalar.quarto"
                        label="Quarto"
                        v-model="data.model.finalizacao.encaminhamentoHospitalar.quarto"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.encaminhamentoHospitalar.leito"
                        label="Leito"
                        v-model="data.model.finalizacao.encaminhamentoHospitalar.leito"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        label="Médico hospitalar"
                        :validations="validations.encaminhamentoHospitalar.medicoHospitalar"
                        v-model="data.model.finalizacao.encaminhamentoHospitalar.medicoHospitalar"
                        uppercase
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :searchFields="fields.autocomplete.encaminhamentoHospitalar.cid"
                        :repository="repositories.cid"
                        :validations="validations.encaminhamentoHospitalar.cidId"
                        label="CID10"
                        v-model="data.model.finalizacao.encaminhamentoHospitalar.cid"
                    >
                        <template v-slot:itemLabel="{ item }">
                            {{ item.codigo | formatCid }} - {{ item.nome }}
                        </template>
                    </rkm-form-input-autocomplete>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :validations="validations.encaminhamentoHospitalar.observacoes"
                        label="Observações"
                        v-model="data.model.finalizacao.encaminhamentoHospitalar.observacoes"
                    />
                </rkm-col>
            </rkm-row>
        </template>

        <template v-if="data.model.finalizacao.desfechoId == enums.desfecho.OBITO">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        disabled
                        label="Paciente"
                        v-model="data.form.paciente.nome"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-date-picker
                        :validations="validations.obito.dataObito"
                        :max-date="data.form.dataAtual"
                        label="Data de óbito"
                        v-model="data.model.finalizacao.obito.dataObito"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-time-picker
                        :validations="validations.obito.horaObito"
                        label="Hora de óbito"
                        v-model="data.model.finalizacao.obito.horaObito"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :validations="validations.obito.declaracao"
                        label="Número da declaração de óbito"
                        v-model="data.model.finalizacao.obito.declaracao"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input-autocomplete
                        :searchFields="fields.autocomplete.obito.cid"
                        :repository="repositories.cid"
                        :validations="validations.obito.cidId"
                        label="CID10"
                        placeholder="CID10 referente a causa do óbito"
                        v-model="data.model.finalizacao.obito.cid"
                    >
                        <template v-slot:itemLabel="{ item }">
                            {{ item.codigo | formatCid }} - {{ item.nome }}
                        </template>
                    </rkm-form-input-autocomplete>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :validations="validations.obito.causa"
                        label="Causa do óbito"
                        v-model="data.model.finalizacao.obito.causa"
                    />
                </rkm-col>
            </rkm-row>
        </template>

        <modal-impressao
            :from-observacao="data.additionals.fromObservacao"
            ref="ModalImpressao"
        />

        <ModalAssinaturaEletronica
            :after-sign="afterSign"
            :ref="modalAssinaturaEletronicaRefName"
            @sign="onSign"
            @skip-sign="onSkipSign"
            v-bind="modalAssinaturaEletronicaFaaProps"
        />
    </rkm-form>
</template>

<script>
// Components.
import ModalImpressao from '@/components/pronto-atendimento/impressao/components/impressao/Modal'

// Enums.
import desfecho from '@/enums/pronto-atendimento/desfecho'
import documentoTipo from '@/enums/cadastro/documentoTipo'
import atestadoModelo from '@/enums/pronto-atendimento/atendimento-medico/atestadoModelo'
import tipoAplicacao from '@/enums/pronto-atendimento/receita/tipoAplicacao'
import tipoAtendimento from '@/enums/pronto-atendimento/parametrizacao/tipoAtendimento'
import tipoPosologia from '@/enums/pronto-atendimento/receita/tipoPosologia'
import viaAdministracao from '@/enums/cadastro/medicamento/viaAdministracao'

// Filters.
import formats from '@/filters/formats'

// Mixins.
import { error, repository, unmask, prontoAtendimentoAssinaturaEletronica } from '@/mixins'

// Others.
import moment from 'moment'

// Utils.
import string from '@/utils/stringCase'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { ModalImpressao },
    computed: {
        validations() {
            const doesntHavePacienteObservacao = this.data.form.pacienteObservacao === null
            return {
                evasao: {
                    motivo: { required: true, min: 1, max: 200 },
                },
                encaminhamentoHospitalar: {
                    unidadeId: {
                        required: doesntHavePacienteObservacao
                    },
                    unidadeNome: {
                        required: doesntHavePacienteObservacao,
                        max: 150
                    },
                    quarto: { max: 3 },
                    leito: { max: 3 },
                    cidId: {
                        required: doesntHavePacienteObservacao
                    },
                    medicoHospitalar: { max: 150, name: true },
                    observacoes: { max: 3000 },
                },
                obito: {
                    dataObito: { required: doesntHavePacienteObservacao },
                    horaObito: { required: doesntHavePacienteObservacao },
                    declaracao: { numeric: true, min: 8, max: 13 },
                    causa: { required: doesntHavePacienteObservacao, min: 1, max: 250 },
                    cidId: { required: doesntHavePacienteObservacao },
                },
            }
        },
    },
    created() {
        this.repositories.atendimentoMedico = this.getConectaSusRepository('prontoAtendimento.atendimentoMedico')
        this.repositories.cid = this.getConectaSusRepository('sigtap.cid')
    },
    data: () => ({
        enums: { desfecho, documentoTipo, atestadoModelo, tipoAplicacao, tipoAtendimento, tipoPosologia, viaAdministracao },
        fields: {
            autocomplete: {
                obito: {
                    cid: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true },
                    ],
                },
                encaminhamentoHospitalar: {
                    cid: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true },
                    ],
                },
            },
            table: [
                { key: 'info', label: '#', class: 'col-min text-nowrap' },
                { key: 'lotacao.ocupacao.codigo', label: 'CBO', class: 'col-min text-nowrap' },
                { key: 'lotacao.profissional.nome', label: 'Profissional', class: 'col-min' },
                { key: 'codigo', label: 'Código', class: 'col-min text-nowrap' },
                { key: 'procedimento.nome', label: 'Procedimento' },
            ]
        },
        repositories: {},
    }),
    filters: {
        ...formats,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        validate() {

            return this.$refs.RkmForm.validate()
        },
        handleDesfechoChange() {
            this.resetDesfecho()

            if (this.data.model.finalizacao.desfechoId === this.enums.desfecho.ENCAMINHAMENTO_HOSPITALAR) {
                this.data.model.finalizacao.encaminhamentoHospitalar.cid = Object.assign({}, this.data.model.cid)
            }
            else if (this.data.model.finalizacao.desfechoId === this.enums.desfecho.OBITO) {
                this.data.model.finalizacao.obito.cid = Object.assign({}, this.data.model.cid)
            }
        },
        save() {

            this.$refs.RkmForm.validate().then(response => {
                if (response === true) {
                    if (this.data.model.classificacaoRiscoId === null) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar a classificação de risco.'
                        })
                    }
                    else if (this.data.form.reavaliacao && this.data.model.evolucao === null) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'Evolução Médica é obrigatório.'
                        })
                    }
                    else if (
                        this.data.form.tipoAtendimentoId === this.enums.tipoAtendimento.ESTRUTURADO &&
                        !this.data.form.reavaliacao &&
                        !this.data.model.queixaPrincipalDuracao &&
                        !this.data.model.historia &&
                        !this.data.model.exameFisico &&
                        !this.data.model.diagnostico &&
                        !this.data.model.conduta
                    ) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: `
                                Obrigatório preencher ao menos um dos items (Queixa Principal e Duração, História do Paciente,
                                Exame Físico, Diagnóstico ou Conduta).
                            `
                        })
                    }
                    else if (
                        this.data.form.tipoAtendimentoId === this.enums.tipoAtendimento.SIMPLES &&
                        !this.data.form.reavaliacao &&
                        !this.data.model.atendimentoGeral
                    ) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'Atendimento Geral é obrigatório.'
                        })
                    }
                    else if (this.data.model.cid === null) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar o CID10.'
                        })
                    }
                    else if (this.data.form.reavaliacao === false
                        && this.data.model.procedimentos.length === 0
                        && !this.hasProcedimentoParametrizado()
                    ) {

                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar ao menos um procedimento.'
                        })
                    }

                    else if (this.data.model.finalizacao.desfechoId === null) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'Desfecho é obrigatório.'
                        })
                    }
                    else if (this.data.model.raat && this.data.model.raat.parecermedico && !this.data.model.solicitouReavaliacao
                        && this.data.model.raat.id !== null
                        && this.data.model.raat.parecerMedico.agenteId === null
                    ) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'Raat é obrigatória.'
                        })
                    }
                    else {
                        this.setLoading()

                        let request = {
                            plantaoId: this.plantaoId,
                            atendimentoId: this.data.model.atendimentoId,
                            classificacaoRiscoId: this.data.model.classificacaoRiscoId,
                            alergias: this.data.model.alergias.map(item => {
                                return {
                                    alergiaId: item.alergia.id,
                                    criticidadeId: item.alergia.criticidade.id,
                                    reacoesObservacoes: item.alergia.reacoesObservacoes,
                                }
                            }),
                            medicamentosUso: this.data.model.medicamentosUso,
                            medicamentosUsoContinuo: this.data.model.medicamentosUsoContinuo.map(item => ({
                                medicamentoId: item.medicamento.id
                            })),
                            fatoresRisco: this.data.model.fatoresRisco,
                            fatorRiscoOutro: this.data.model.fatorRiscoOutro,
                            sinaisVitais: this.data.model.sinaisVitais.map(item => {
                                return {
                                    pa: item.pa || null,
                                    paUnidadeMedidaId: item.pa ? item.paUnidadeMedidaId : null,
                                    glicemia: item.glicemia || null,
                                    temperatura: item.temperatura ? this.unMaskTemperaturaMMDG(item.temperatura) : null,
                                    pulso: item.pulso || null,
                                    respiracao: item.respiracao || null,
                                    saturacao: item.saturacao || null,
                                    intensidadeDor: item.intensidadeDor || null,
                                    cintura: item.cintura || null,
                                }
                            }),
                            gestacao: {
                                gestante: this.data.model.gestacao.gestante,
                                dum: this.data.model.gestacao.dum ? moment(this.data.model.gestacao.dum).format('YYYY-MM-DD') : null,
                            },
                            evolucao: this.data.model.evolucao,
                            atendimentoGeral: this.data.model.atendimentoGeral,
                            queixaPrincipalDuracao: this.data.model.queixaPrincipalDuracao,
                            historia: this.data.model.historia,
                            exameFisico: this.data.model.exameFisico,
                            diagnostico: this.data.model.diagnostico,
                            conduta: this.data.model.conduta,
                            observacoesEnfermagem: this.data.model.observacoesEnfermagem,
                            observacoes: this.data.model.observacoes,
                            dorToracicaProtocoloFinalizado: this.data.model.dorToracicaProtocoloFinalizado,
                            dorToracicaProtocoloTemProsseguimento: this.data.model.dorToracicaProtocoloTemProsseguimento,
                            dorToracicaResultadoEletrocardiograma: this.data.model.dorToracicaResultadoEletrocardiograma,
                            dorToracicaTemContraIndicacaoTrombolitico: this.data.model.dorToracicaTemContraIndicacaoTrombolitico,
                            dorToracicaContraIndicacaoTromboliticoMotivo: this.data.model.dorToracicaContraIndicacaoTromboliticoMotivo,
                            dorToracicaSinaisInstabilidade: this.data.model.dorToracicaSinaisInstabilidade,
                            cidId: this.data.model.cid.id,
                            procedimentos: this.data.model.procedimentos.map(item => {
                                return {
                                    procedimentoId: item.procedimento.id,
                                    cidPrincipalId: item.cidPrincipal ? item.cidPrincipal.id : null,
                                    quantidade: item.quantidade,
                                }
                            }),
                            encaminhamentos: this.data.model.encaminhamentos.map(item => {
                                return {
                                    urgente: item.urgente,
                                    ocupacaoId: item.ocupacao.id,
                                    motivo: item.motivo,
                                    observacoes: item.observacoes,
                                }
                            }),
                            servicosEnfermagem: this.data.model.servicosEnfermagem.map(item => {
                                return {
                                    procedimentoId: item.procedimento.id,
                                    observacoes: item.observacoes,
                                }
                            }),
                            declaracoesComparecimento: this.data.model.declaracoesComparecimento.map(item => {
                                const de = moment(moment(item.dataDe).format('YYYY-MM-DD') + ' ' + item.horaDe).format('YYYY-MM-DD HH:mm')
                                const ate = moment(moment(item.dataAte).format('YYYY-MM-DD') + ' ' + item.horaAte).format('YYYY-MM-DD HH:mm')
                                let documentoNumero = item.documentoNumero

                                switch (item.tipoId) {
                                    case this.enums.documentoTipo.CPF:
                                        documentoNumero = this.unMaskCpf(documentoNumero)
                                        break;

                                    case this.enums.documentoTipo.CNS:
                                        documentoNumero = this.unMaskCns(documentoNumero)
                                        break;
                                }

                                return {
                                    tipoId: item.tipoId,
                                    nome: item.nome,
                                    documentoTipoId: item.documentoTipoId,
                                    documentoNumero: documentoNumero,
                                    de: de,
                                    ate: ate,
                                    motivo: item.motivo,
                                }
                            }),
                            prescricoesInternas: this.data.model.prescricoesInternas.map(item => {
                                return {
                                    doseUnica: item.doseUnica,
                                    frequenciaQuantidadeVezes: item.frequenciaQuantidadeVezes,
                                    frequenciaTempo: item.frequenciaTempo,
                                    frequenciaMedidaTempoId: item.frequenciaMedidaTempoId,
                                    observacoes: item.observacoes,
                                    medicamentos: item.medicamentos.map(medicamento => {
                                        return {
                                            medicamentoId: medicamento.medicamento.id,
                                            unidadeMedidaId: medicamento.unidadeMedidaId,
                                            quantidade: medicamento.quantidade,
                                            administracao: medicamento.administracao,
                                        }
                                    }),
                                }
                            }),
                            orientacoes: this.data.model.orientacoes,
                            receitasMedicasAssinadas: this.data.model.receitasMedicasAssinadas,
                            cancelamentoDesfecho: false,
                        }

                        request.receitaMedica = {
                            isAssinada: this.data.model.receitaMedica.isAssinada,
                            medicamentos: []
                        }

                        if (this.data.model.receitaMedica.medicamentos.length > 0) {

                            request.receitaMedica.medicamentos = this.data.model.receitaMedica.medicamentos
                                .map(item => {

                                    let data = {
                                        prescricaoManual: item.prescricaoManual ? item.prescricaoManual : null,
                                        medicamentoId: null,
                                        medicamentoManual: null,
                                    }

                                    if (!item.prescricaoManual) {
                                        data.medicamentoId = item.medicamentoCadastrado == 1 ? item.medicamento.id : null
                                        data.medicamentoManual = item.medicamentoCadastrado == 2 ? item.medicamentoManual : null
                                    }

                                    if (item.viaAdministracao.id === this.enums.viaAdministracao.OUTRAS) {

                                        data.viaAdministracaoOutras = item.viaAdministracaoOutras
                                    }

                                    switch (item.tipoAplicacao.id) {

                                        case this.enums.tipoAplicacao.DOSE_UNICA: {

                                            return {
                                                ...data,
                                                tipoAplicacao: 'dose_unica',
                                                quantidade: item.quantidade,
                                                recomendacoes: item.recomendacoes,
                                            }
                                        }
                                        case this.enums.tipoAplicacao.USO_CONTINUO: {

                                            data = {
                                                ...data,
                                                tipoAplicacao: 'uso_continuo',
                                                quantidade: item.quantidade,
                                                tipoPosologia: item.tipoPosologia === this.enums.tipoPosologia.FREQUENCIA
                                                    ? 'frequencia'
                                                    : 'turno',
                                                recomendacoes: item.recomendacoes,
                                            }

                                            return item.tipoPosologia === this.enums.tipoPosologia.FREQUENCIA
                                                ? {
                                                    ...data,
                                                    intervaloTempo: item.intervaloTempo,
                                                    intervaloMedidaTempoId: item.intervaloMedidaTempo.id,
                                                }
                                                : {
                                                    ...data,
                                                    turnoId: item.turno.id
                                                }
                                        }
                                        case this.enums.tipoAplicacao.LIVRE: {

                                            return {
                                                ...data,
                                                tipoAplicacao: 'livre',
                                                descricao: item.descricao,
                                            }
                                        }
                                        default: {

                                            data = {
                                                ...data,
                                                tipoAplicacao: 'padrao',
                                                tipoPosologia: item.tipoPosologia === this.enums.tipoPosologia.FREQUENCIA
                                                    ? 'frequencia'
                                                    : 'turno',
                                                quantidade: item.quantidade,
                                                duranteTempo: item.duranteQuantidade,
                                                duranteMedidaTempoId: item.duranteMedidaTempo.id,
                                                recomendacoes: item.recomendacoes,
                                            }

                                            return item.tipoPosologia === this.enums.tipoPosologia.FREQUENCIA
                                                ? {
                                                    ...data,
                                                    intervaloTempo: item.intervaloTempo,
                                                    intervaloMedidaTempoId: item.intervaloMedidaTempo.id,
                                                }
                                                : {
                                                    ...data,
                                                    turnoId: item.turno.id
                                                }
                                        }
                                    }
                                })
                        }

                        if (this.data.model.avaliacaoAntropometrica.massa || this.data.model.avaliacaoAntropometrica.altura) {
                            request.avaliacaoAntropometrica = {
                                massa: this.data.model.avaliacaoAntropometrica.massa,
                                massaUnidadeMedidaId: this.data.model.avaliacaoAntropometrica.massaUnidadeMedidaId,
                                alturaTipoMedidaId: this.data.model.avaliacaoAntropometrica.alturaTipoMedidaId,
                                altura: this.data.model.avaliacaoAntropometrica.altura,
                                alturaUnidadeMedidaId: this.data.model.avaliacaoAntropometrica.alturaUnidadeMedidaId,
                            }
                        }

                        if (this.data.model.pedidosExames.id) {
                            request.pedidosExames = {
                                urgente: this.data.model.pedidosExames.urgente,
                                justificativa: this.data.model.pedidosExames.justificativa,
                                exames: this.data.model.pedidosExames.exames.map(item => {
                                    return {
                                        exameId: item.id,
                                        observacaoMedico: item.observacaoMedico || null,
                                    }
                                }),
                            }
                        }

                        const atestado = this.data.model.atestado || {}
                        const hasAtestadoData = !!(
                            atestado.documentoTipoId
                            || atestado.documentoNumero
                            || atestado.nome
                        )
                        const hasModeloId =
                            atestado.modeloId !== null
                            && atestado.modeloId !== undefined
                            && atestado.modeloId !== ''
                        const isModeloPadrao = Number(atestado.modeloId) === this.enums.atestadoModelo.PADRAO
                        const isModeloQuantidadeHoras = Number(atestado.modeloId) === this.enums.atestadoModelo.QUANTIDADE_HORAS
                        const hasDias = atestado.dias !== null && atestado.dias !== undefined && atestado.dias !== ''
                        const hasHorarioQuantidadeHoras = !!(atestado.horarioInicial && atestado.quantidadeHoras)
                        const canSendAtestado = hasAtestadoData
                            && hasModeloId
                            && (!isModeloPadrao || hasDias)
                            && (!isModeloQuantidadeHoras || hasHorarioQuantidadeHoras)

                        if (canSendAtestado) {
                            let documentoNumero = atestado.documentoNumero
                            const horarioInicial = atestado.horarioInicial
                                ? moment(atestado.horarioInicial, ['HH:mm:ss', 'HH:mm']).format('HH:mm')
                                : null

                            switch (parseInt(atestado.documentoTipoId)) {
                                case this.enums.documentoTipo.CPF:
                                    documentoNumero = documentoNumero ? this.unMaskCpf(documentoNumero) : null
                                    break;

                                case this.enums.documentoTipo.CNS:
                                    documentoNumero = documentoNumero ? this.unMaskCns(documentoNumero) : null
                                    break;
                            }

                            request.atestado = {
                                nomeAcompanhante: atestado.paciente == 0 ? atestado.nome : null,
                                paciente: atestado.paciente,
                                imprimeCid: atestado.imprimeCid,
                                modeloId: atestado.modeloId,
                                dias: atestado.dias,
                                horarioInicial: horarioInicial,
                                quantidadeHoras: atestado.quantidadeHoras,
                                documentoTipoId: atestado.documentoTipoId,
                                documentoNumero: documentoNumero,
                            }
                        }

                        if (this.data.model.raat && this.data.model.raat.parecermedico && this.data.model.raat.parecerMedico.agenteId) {
                            request.raat = {
                                agenteId: this.data.model.raat.parecerMedico.agenteId,
                                partesCorpoAtingidas: this.data.model.raat.parecerMedico.partesCorpoAtingidas,
                                parteCorpoAtingidaOutras: this.data.model.raat.parecerMedico.parteCorpoAtingidaOutras,
                                causasAcidente: this.data.model.raat.parecerMedico.causasAcidente,
                                causaAcidenteOutras: this.data.model.raat.parecerMedico.causaAcidenteOutras,
                                diagnosticos: this.data.model.raat.parecerMedico.diagnosticos,
                                diagnosticoOutros: this.data.model.raat.parecerMedico.diagnosticoOutros,
                                observacao: this.data.model.raat.parecerMedico.observacao,
                                classificacaoInicialId: this.data.model.raat.parecerMedico.classificacaoInicialId,
                                afastado: this.data.model.raat.parecerMedico.afastado,
                            }
                        }

                        if (this.data.model.finalizacao.desfechoId) {
                            request.finalizacao = {
                                desfecho_id: this.data.model.finalizacao.desfechoId,

                            }

                            if (this.data.model.finalizacao.desfechoId === this.enums.desfecho.EVASAO) {
                                request.finalizacao = Object.assign(request.finalizacao , {
                                    evasao: {
                                        motivo: this.data.model.finalizacao.evasao.motivo,
                                    }
                                })
                            }
                            else if (this.data.model.finalizacao.desfechoId === this.enums.desfecho.ENCAMINHAMENTO_HOSPITALAR) {
                                request.finalizacao = Object.assign(request.finalizacao , {
                                    encaminhamentoHospitalar: {
                                        unidadeId: this.data.model.finalizacao.encaminhamentoHospitalar.unidadeId,
                                        unidadeNome: this.data.model.finalizacao.encaminhamentoHospitalar.unidadeNome,
                                        quarto: this.data.model.finalizacao.encaminhamentoHospitalar.quarto,
                                        leito: this.data.model.finalizacao.encaminhamentoHospitalar.leito,
                                        cidId: this.data.model.finalizacao.encaminhamentoHospitalar.cid
                                            ? this.data.model.finalizacao.encaminhamentoHospitalar.cid.id
                                            : null,
                                        medicoHospitalar: this.data.model.finalizacao.encaminhamentoHospitalar.medicoHospitalar,
                                        tipoTransporteId: this.data.model.finalizacao.encaminhamentoHospitalar.tipoTransporteId,
                                        observacoes: this.data.model.finalizacao.encaminhamentoHospitalar.observacoes,
                                    },
                                })
                            }
                            else if (this.data.model.finalizacao.desfechoId === this.enums.desfecho.OBITO) {
                                request.finalizacao = Object.assign(request.finalizacao , {
                                    obito: {
                                        obitoEm: moment(
                                            moment(
                                                this.data.model.finalizacao.obito.dataObito).format('YYYY-MM-DD') + ' ' +
                                                this.data.model.finalizacao.obito.horaObito
                                            ).format('DD/MM/YYYY HH:mm'),
                                        declaracao: this.data.model.finalizacao.obito.declaracao,
                                        causa: this.data.model.finalizacao.obito.causa,
                                        cidId: this.data.model.finalizacao.obito.cid
                                            ? this.data.model.finalizacao.obito.cid.id
                                            : null
                                    },
                                })
                            }
                        }


                        this.repositories.atendimentoMedico.store(string.camelObjectKeysToSnakeRecursive(request))
                            .then(({ data }) => {

                                const finish = () => {

                                    this.$refs.ModalImpressao.open(
                                        data.impressoes,
                                        data.atendimentoId,
                                        () => this.$emit('save')
                                    )
                                }

                                if (data.assinar) {

                                    this.afterSign = faaAssinada => {

                                        return this.repositories.atendimentoMedico.storeFaaAssinada(data.id, {
                                            faa_assinada: faaAssinada
                                        })
                                    }

                                    this.onSign = () => finish()
                                    this.onSkipSign = () => finish()

                                    this.askToSignAtendimento(
                                        async () => this.signFaa(
                                            data.atendimentoId,
                                            [{ tipo: 'medico', id: data.id }],
                                            `faa-${data.faaId}-atendimento-medico-${data.id}`
                                        ),
                                        async () => finish()
                                    )
                                }
                                else {

                                    this.showSaveNotification()

                                    finish()
                                }
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                }
            })
        },
        hasProcedimentoParametrizado() {

            if (this.data.form.procedimentos.length === 0) {

                return false
            }

            return this.data.form.procedimentos.find(p => p.procedimento.isParametrizado)
        },
        resetDesfecho() {
            this.data.model.finalizacao = Object.assign(this.data.model.finalizacao, {
                evasao: {
                    motivo: null,
                },
                encaminhamentoHospitalar: {
                    unidadeId: null,
                    unidadeOutra: false,
                    unidadeNome: null,
                    quarto: null,
                    leito: null,
                    cid: null,
                    medicoHospitalar: null,
                    tipoTransporteId: null,
                    observacoes: null,
                },
                obito: {
                    dataObito: null,
                    horaObito: null,
                    obitoEm: null,
                    declaracao: null,
                    causa: null,
                    cid: null,
                },
            })
        },
    },
    mixins: [error, repository, unmask, prontoAtendimentoAssinaturaEletronica],
    props: {
        data: { type: Object, required: true },
        plantaoId: { type: [String, Number], required: true },
    },
    watch: {
        'data.model.finalizacao.encaminhamentoHospitalar.unidadeOutra'(value) {
            if (value === true) {
                this.data.model.finalizacao.encaminhamentoHospitalar.unidadeId = null
            } else {
                this.data.model.finalizacao.encaminhamentoHospitalar.unidadeNome = null
            }
        }
    }
}
</script>